<template>
  <v-layout>
    <v-flex>
      <v-layout class="mb-n3" v-show="$vuetify.breakpoint.smAndDown">
        <v-flex>
          <img width="100%" src="../assets/footer/footer-white bg.png" alt="" />
        </v-flex>
      </v-layout>

      <v-layout
        class="pa-lg-12 pa-md-12 pa-sm-12 pa-0"
        justify-space-between
        :column="$vuetify.breakpoint.smAndDown"
        white--text
        style="background: #26262A;position: relative"
      >
        <v-flex d-flex justify-center align-center xs4 style="">
          <img
            v-if="$vuetify.breakpoint.mdAndUp"
            style="position: absolute;top:0;width: 487px;margin-top: -76px"
            src="../assets/footer/footer-graphic-2x.png"
          />
          <!-- <img
            v-if="$vuetify.breakpoint.sm"
            style="width: 65%;margin-top: -116px;margin-bottom: 5rem;"
            src="../assets/footer/footer-graphic-2x.png"
          /> -->
          <!-- <img
            v-if="$vuetify.breakpoint.xs"
            style="width: 65%;margin-top: -38px;margin-bottom: 5rem;"
            src="../assets/footer/footer-graphic-2x.png"
          /> -->
        </v-flex>
        <!-- footer menu  -->
        <v-flex class="pt-12 xs4 ml-sm-12 d-flex justify-center align-center">
          <v-layout mb-3 mb-md-0 class="justify-center">
            <v-spacer v-if="$vuetify.breakpoint.mdAmdUp"></v-spacer>
            <v-flex xs6 pl-4 style="line-height: 35px">
              <div v-for="(item, i) in firstColumn" :key="i">
                <span class="footer-link" @click="onActive(item.link)">{{
                  item.name
                }}</span>
              </div>
            </v-flex>
            <v-flex xs6 style="line-height: 35px">
              <div v-for="(item, i) in secondColumn" :key="i">
                <span class="footer-link" @click="onActive(item.link)">{{
                  item.name
                }}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- footer contact  -->
        <v-flex class="xs4 d-flex justify-center align-center ">
          <v-layout class="">
            <v-flex
              class=""
              :class="{
                'text-end': $vuetify.breakpoint.mdAndUp,
                'text-center': $vuetify.breakpoint.smAndDown,
              }"
            >
              <v-layout column>
                <v-flex
                  class="d-flex xs4 my-lg-6 my-md-6 my-sm-12 my-12"
                  :class="
                    $vuetify.breakpoint.smAndDown
                      ? 'justify-center'
                      : 'justify-end'
                  "
                >
                  <img
                    class=""
                    :width="$vuetify.breakpoint.smAndDown ? '30%' : '20%'"
                    :src="require('../assets/icons/logo/logo@2x.png')"
                  />
                </v-flex>
                <v-flex
                  class="xs6 d-flex justify-end align-center"
                  mb-5
                  :class="{
                    'align-self-center': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <!-- only mobile size -->
                  <div v-if="$vuetify.breakpoint.smAndDown">
                    <div
                      style="border: solid 1px #FFF; border-radius: 30px; width: 335px"
                      class="mb-3 py-3 px-4"
                    >
                      connect@cea.or.th
                    </div>
                    <div
                      style="border: solid 1px #FFF; border-radius: 30px; width: 335px"
                      class="py-3 px-4 "
                    >
                      (+66) 2 105 7400 ext. 118 - 131
                    </div>
                  </div>
                  <!-- only desktop size -->
                  <div v-else>
                    <span
                      style="border: solid 1px #FFF; border-radius: 30px;"
                      class="py-2 px-4 txt-detail"
                      >connect@cea.or.th (+66) 2 105 7400 ext. 118 - 131</span
                    >
                  </div>
                </v-flex>

                <v-flex xs4>
                  <v-layout
                    class="flex-center justify-space-between my-8 my-lg-0 my-md-0 my-sm-0"
                  >
                    <v-spacer v-show="$vuetify.breakpoint.smAndUp"></v-spacer>
                    <v-flex shrink mx-4>
                      <img
                        style="cursor:pointer;"
                        width="50px"
                        :src="require('../assets/footer/gov.png')"
                        @click="openLink('https://www.egov.go.th/th/index.php')"
                      />
                    </v-flex>
                    <v-flex shrink mx-4>
                      <img
                        style="cursor:pointer;"
                        width="50px"
                        :src="require('../assets/footer/cea.png')"
                        @click="openLink('https://www.cea.or.th/')"
                      />
                    </v-flex>
                    <v-flex shrink mx-4>
                      <img
                        style="cursor:pointer;"
                        width="55px"
                        :src="require('../assets/footer/tcdc.png')"
                        @click="openLink('https://www.tcdc.or.th/')"
                      />
                    </v-flex>
                    <v-flex shrink mx-4>
                      <img
                        style="cursor:pointer;"
                        width="75px"
                        :src="require('../assets/footer/think.png')"
                        @click="
                          openLink('https://www.creativethailand.org/home')
                        "
                      />
                    </v-flex>
                    <v-spacer v-show="$vuetify.breakpoint.sm"></v-spacer>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout
        pa-4
        style="background-color: #000;color: #fff;position: relative"
      >
        <v-flex class="flex-center">
          <span>©2020 ALL RIGHTS RESERVED.</span>
        </v-flex>
      </v-layout>

      <loading
        color="#FD5246"
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
      ></loading>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Footer",

  data: () => ({
    isLoading: false,
    firstColumn: [],
    secondColumn: [],
    isActive: "",
  }),
  components: {
    Loading,
  },
  computed: {
    i18n: function() {
      return this.$i18n.locale;
    },
    ...mapState({
      path_url: (state) => {
        return state.Page.path_url;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  watch: {
    i18n: function() {
      this.setColumn();
    },
  },
  created() {
    this.setColumn();
  },
  methods: {
    ...mapActions("Page", ["getDataPage", "setPathUrl"]),
    setColumn() {
      this.firstColumn = [
        {
          name: this.$t("home"),
          link: "home",
        },
        {
          name: this.$t("portfolio"),
          link: "portfolio",
        },
        {
          name: this.$t("creator-portfolio"),
          link: "creator",
        },
        // {
        //     name: this.$t('job'),
        //     link: ''
        // },
        // {
        //     name: this.$t('activity'),
        //     link: ''
        // },
        // {
        //     name: this.$t('content'),
        //     link: 'content',
        // },
        {
          name: this.$t("about-us"),
          link: "about-us",
        },
      ];
      this.secondColumn = [
        {
          name: this.$t("faq"),
          link: "faqs",
        },
        {
          name: this.$t("term"),
          link: "term",
        },
        {
          name: this.$t("policy"),
          link: "privacy-policy",
        },
        {
          name: this.$t("contact"),
          link: "contact",
        },
      ];
    },
    onActive(val) {
      this.isActive = val;
      this.isLoading = true;
      switch (val) {
        case "home":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 1);
          this.isLoading = false;
          this.$router.push("/homepage");
          break;
        case "portfolio":
          this.isLoading = false;
          this.$router.push(
            `/portfolio-category/${
              this.switchLanguage === "th" ? "รวม" : "All"
            }`
          );

          // let data = {
          //   id: 0,
          //   page: 1,
          // };
          // this.$store
          //   .dispatch("portfolio/getPortfolioByIdCategory", data)
          //   .then((res) => {
          //     this.isLoading = false;
          //     if (this.currentRouteName !== "AllPortfolioByCategory") {
          //       this.$router.push("/portfolio-category");
          //     }
          //   });
          break;
        case "creator":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 2);
          this.isLoading = false;
          this.$router.push({ path: "creator" });
          break;
        case "content":
          this.$store
            .dispatch("portfolio/getPortfolioByIdCategory", 0)
            .then((res) => {
              this.isLoading = false;
              if (this.currentRouteName !== "Content") {
                this.$router.push("/content");
              }
            });
          break;
        case "faqs":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
          this.setPathUrl(val);
          this.isLoading = false;
          if (this.$route.name === "Pages") {
            this.getDataPage(val);
          }
          if (this.$route.query.page !== "faqs") {
            this.$router.push({ path: "/pages", query: { page: "faqs" } });
          }
          break;
        case "term":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
          this.setPathUrl(val);
          this.isLoading = false;
          if (this.$route.name === "Pages") {
            this.getDataPage(val);
          }
          if (this.$route.query.page !== "term") {
            this.isLoading = false;
            this.$router.push({ path: "/pages", query: { page: "term" } });
          }
          break;
        case "privacy-policy":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
          this.setPathUrl(val);
          this.isLoading = false;
          if (this.$route.name === "Pages") {
            this.getDataPage(val);
          }
          if (this.$route.query.page !== "privacy-policy") {
            this.$router.push({
              path: "/pages",
              query: { page: "privacy-policy" },
            });
          }
          break;
        case "contact":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
          this.isLoading = false;
          if (this.$route.name !== "Contact") {
            this.$router.push("/contact");
          }
          break;
        case "about-us":
          this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
          this.isLoading = false;
          this.setPathUrl(val);
          if (this.$route.name === "Pages") {
            this.getDataPage(val);
          }
          if (this.$route.query.page !== "about-us") {
            this.isLoading = false;
            this.$router.push({ path: "/pages", query: { page: "about-us" } });
          }
          break;
      }
      setTimeout(() => {
        this.$vuetify.goTo("#header");
      }, 300);
    },

    openLink(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style scoped>
.footer-link {
  cursor: pointer;
}

.footer-link:hover {
  color: #fd5246;
}
</style>
